import {SHOW_MSG} from "../types";

const messageShow= (payload) => {
    return ({type: SHOW_MSG,payload: payload});
}
export default messageShow;
